import React from 'react';
import {Switch as NBSwitch, ISwitchProps} from 'native-base';

export const Switch = (props: ISwitchProps) => {
  return (
    <NBSwitch {...props}></NBSwitch>
  )
}